import { getIsClient } from './get-is-client';
export var isFormData = function (body) {
    var _a;
    if (!body) {
        return false;
    }
    var isNode = !getIsClient();
    if (isNode) {
        return ((_a = body === null || body === void 0 ? void 0 : body.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'FormData';
    }
    return body instanceof FormData;
};
